module.exports = __webpack_public_path__ + "img/review-like-big.dbf59ad7.png";